// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1BG3m","box":"WorkspacesBox_box__S8gPa","node":"WorkspacesBox_node__1jRmm"};